import React from 'react'
import classnames from 'classnames'

import Icon from './Icon'

export default function LanguageTag ({
  Element = 'li',
  lang,
  icon,
  extraClass
}) {
  return (
    <Element
      className={classnames(
        { 'language-tag--with-icon': icon },
        extraClass,
        'language-tag grid items-center justify-center small px1 mx1 mb2'
      )}
    >
      {icon && (
        <Icon icon={icon} className='icon icon--very-small justify-self-left' />
      )}
      {lang}
    </Element>
  )
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/LanguageTag.js